import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import  { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { AppcontextProvider } from './context/AppContext';
import { AdminProvider, AdminUsersProvider } from './context/AdminContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter>           {/* ✅ TOP LEVEL - EK HI */}
      <AuthProvider>  
        <AppcontextProvider>
       <AdminProvider>

            
        <App />
       </AdminProvider>
          </AppcontextProvider>        {/* ✅ Context INSIDE Router */}
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
